<template>
  <v-container class="fluid-max-width pa-0">
    <v-breadcrumbs :items="breadcrumbItems">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>
    <v-container>
      <FormAddShaft
        :sites="sites"
        :initialSite="initialSite"
        :initialShaft="initialShaft"
        @addSiteClick="addSiteVisible = true"
      />
    </v-container>
    <v-dialog
      v-model="addSiteVisible"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-container class="white" style="margin-top: 60px">
        <FormAddSite :user="user" @submit="siteAdded" />
        <div class="my-4 text-center">
          <v-btn
            color="primary"
            class="text-center"
            outlined
            @click="addSiteVisible = false"
          >
            Abbrechen
          </v-btn>
        </div>
      </v-container>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import FormAddShaft from '@/components/FormAddShaft.vue';
import FormAddSite from '@/components/FormAddSite.vue';

export default {
  name: 'AddShaft',
  components: { FormAddShaft, FormAddSite },
  data: () => ({
    addSiteVisible: false,
    initialSite: undefined,
    initialShaft: undefined,
    breadcrumbItems: [
      {
        text: 'Home',
        disabled: false,
        to: '/',
      },
      {
        text: 'Baustellen',
        disabled: false,
        to: '/baustellen/',
      },
      {
        text: 'Schacht hinzufügen',
        disabled: true,
        to: '/schacht/add',
      },
    ],
  }),
  computed: {
    ...mapGetters(['user', 'sites']),
  },
  watch: {
    sites() {
      if (this.initialSite) {
        this.sites.forEach(site => {
          if (
            site.name === this.initialSite.name &&
            site.postal_code === this.initialSite.postal_code
          )
            this.initialSite = site.id;
        });
      }
    },
  },
  async created() {
    await this.autoLogin();
    await this.getSites();
    if (this.$route.query.site) {
      this.initialSite = this.$route.query.site;
      this.initialShaft = this.$route.query.shaft;
    }
  },
  methods: {
    ...mapActions(['autoLogin', 'getUser', 'getSites']),
    siteAdded(site) {
      this.initialSite = site.id;
      this.addSiteVisible = false;
    },
  },
};
</script>

<style scoped></style>
